import BaseService from "@/services/BaseService";
export default class RecordTypeService extends BaseService{
  constructor() {
    super('odoo/record_type');
  }

  async findAllByModel(model) {
    return await this.http.get(this._serviceName, { params: {'objectType': model} });
  }
}
